module.exports = __webpack_public_path__ + "static/img/1075_small.528934f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1075_small.png
// module id = U6KD
// module chunks = 1